import { I18nLang } from '@pharmsnap/shared/i18n'
import { IAccountErrorResponse, IErrorResponse, IHttpWrapError } from '@pharmsnap/shared/service/http/types'
import { getTextByLang } from '../../lang'
import { showSingleToast } from '../../toast'
const overLimitMessage = {
  cn: '亲爱的用户，您的账号检索使用已达上限，请点击右上角的账号升级申请获取更多权限',
  en: 'Dear user, your account retrieval has reached the limit, please click the upgrade button on the upper right corner',
  jp: 'お客様のアカウントの検索利用回数が上限に達しました。右上のアカウントアップグレード申請をクリックして、より多くの権限を取得してください',
}

const usageLimitMessage = {
  cn: '亲爱的用户，您当前功能的使用次数已达上限，<a href="/usage" target="_blank" style="cursor: pointer; text-decoration: underline">点击查看账户升级说明</a>',
  en: 'Dear user, your current usage in this function has reached the limit. <a href="/usage" target="_blank" style="cursor: pointer; text-decoration: underline">Please click to view the account upgrade</a>',
  jp: 'お客様の現在の機能の利用回数が上限に達しました。<a href="/usage" target="_blank" style="cursor: pointer; text-decoration: underline">クリックしてアカウントアップグレードの説明をご確認ください</a>',
}
const withoutAccessMessage = {
  cn: '亲爱的用户，您当前权限不足，<a href="/usage" target="_blank" style="cursor: pointer; text-decoration: underline">点击查看账户升级说明</a>',
  en: "Dear user, you can't access to this function.  <a href='/usage' target='_blank' style='cursor: pointer; text-decoration: underline'>Please click to view the account upgrade</a>",
  jp: 'お客様の権限が不足しています。<a href="/usage" target="_blank" style="cursor: pointer; text-decoration: underline">クリックしてアカウントアップグレードの説明をご確認ください</a>',
}
const errorCodeMessageMap: Record<number, { en: string; cn: string; jp: string }> = {
  // '-1': {
  //   cn: '服务器内部错误',
  //   en: 'Serve Error',
  // },
  130068: {
    cn: '该手机号已注册，可直接使用手机号登录',
    en: 'Phone number has registered',
    jp: 'この携帯番号は登録済みです。携帯番号でログインできます',
  },
  130069: {
    cn: '自定义分析名称已存在',
    en: 'Another dashboard with the same name already exists. Please enter a different name',
    jp: '同じ名前のカスタム分析がすでに存在します。別の名前を入力してください',
  },
  130076: {
    cn: '图表名称重复,请修改',
    en: 'Chart Already Exist',
    jp: 'チャート名が重複しています。変更してください',
  },
  130078: {
    cn: '公共号关注成功，但该微信已经绑定其他智慧芽账号，请使用其他微信账号',
    en: 'Already bound, please change another',
    jp: 'すでに他のアカウントに紐付けられています。別のアカウントをご利用ください',
  },
  130081: usageLimitMessage,
  10004: withoutAccessMessage,
  130082: {
    cn: '图表数量超过每个自定义分析的最大限制',
    en: 'The number of charts exceeds the limit per dashboard',
    jp: 'チャート数がカスタム分析ごとの上限を超えています',
  },
  130085: {
    cn: '已设置该情报监控',
    en: 'This email alert has been set',
    jp: 'このアラートはすでに設定されています',
  },
  130086: {
    cn: '已达到情报监控最大设置数量,请升级您的订阅计划',
    en: 'The maximum number of email alerts has been reached, please upgrade your subscription plan',
    jp: 'アラートの設定数が上限に達しました。サブスクリプションプランをアップグレードしてください',
  },
  130087: {
    cn: '已达到最大可发送邮箱地址数',
    en: 'The maximum number of email addresses has been reached',
    jp: '送信可能なメールアドレス数が上限に達しました',
  },
  130088: {
    cn: '情报监控的标题已存在',
    en: 'Alert title already exist',
    jp: 'このアラートのタイトルはすでに存在します',
  },
  130133: {
    cn: '创建失败，检索结果数量超过限制',
    en: 'Create failed, the search results exceed the limit',
    jp: '作成に失敗しました。検索結果の件数が上限を超えています',
  },
  130135: {
    cn: '存在实体不支持设置监控',
    en: 'There are entities that do not support setting alerts',
    jp: 'アラート設定に対応していないエンティティが含まれています',
  },
  30101: {
    cn: '该账号不存在',
    en: "this mobile number doesn't exist",
    jp: 'このアカウントは存在しません',
  },
  30102: {
    cn: '您的帐号存在非法操作，已被禁用。您如果对此存在疑问，请联系您的管理员。',
    en: 'Your account has been disabled for illegal activity. If you have questions about this, please contact your administrator.',
    jp: 'お客様のアカウントに不正な操作が確認されたため、利用を停止しました。ご不明な点は管理者にお問い合わせください。',
  },
  30103: {
    cn: '账号不存在或者密码错误',
    en: 'Account does not exist or password is incorrect',
    jp: 'アカウントが存在しない、またはパスワードが正しくありません',
  },
  30103.3: {
    cn: '新密码设置失败，请录入正确的原密码。',
    en: 'Failed to set the new password. Please enter the correct old password.',
    jp: '新しいパスワードの設定に失敗しました。正しい現在のパスワードを入力してください。',
  },
  30111: {
    cn: '您的帐号还未认证，请到您的邮箱点击激活',
    en: 'Your account has not been authenticated. Please activate your account from your email.',
    jp: 'お客様のアカウントは未認証です。メールからアカウントを有効化してください。',
  },
  30116: {
    cn: '密码错误次数到达上限，帐号被锁定。',
    en: 'Your account has been locked as you have reached the maximum number of failed login attempts.',
    jp: 'パスワードの誤入力が上限に達したため、アカウントがロックされました。',
  },
  30118: {
    cn: '登录方式不支持',
    en: 'Login method is not supported',
    jp: 'このログイン方法は対応していません',
  },
  30119: {
    cn: '验证码错误',
    en: 'Wrong verification code',
    jp: '認証コードが正しくありません',
  },
  30122: {
    cn: '手机号未绑定，或账号不存在',
    en: 'Cell phone number is not bound, or the account does not exist',
    jp: '携帯番号が紐付けられていない、またはアカウントが存在しません',
  },
  30125: {
    cn: '公共号关注成功，但该微信已经绑定其他智慧芽账号，请使用其他微信账号',
    en: 'Already bound, please change another',
    jp: 'すでに他のアカウントに紐付けられています。別のアカウントをご利用ください',
  },
  30127: {
    cn: '公共号关注成功，但该微信已经绑定其他智慧芽账号，请使用其他微信账号',
    en: 'Already bound, please change another',
    jp: 'すでに他のアカウントに紐付けられています。別のアカウントをご利用ください',
  },
  30129: {
    cn: '该手机号/邮箱已被使用，请使用其他手机号/邮箱',
    en: 'This phone number or email is already in use, please try another one',
    jp: 'この携帯番号／メールアドレスはすでに使用されています。別のものをご利用ください',
  },
  30178: {
    cn: '该手机号/邮箱已被使用，请使用其他手机号/邮箱',
    en: 'This phone number or email is already in use, please try another one',
    jp: 'この携帯番号／メールアドレスはすでに使用されています。別のものをご利用ください',
  },
  30153: {
    cn: '密码仅可由数字，字母，与英文符号组成，必须包含数字与字母，长度为8-32。',
    en: 'The password can contain only letters, digits, and English symbols, must contain letters and digits, and length is 8 to 32.',
    jp: 'パスワードは半角数字・英字・記号のみ使用でき、数字と英字を含む8〜32文字で設定してください。',
  },
  30123: {
    cn: '密码长度为12-32位字符，必须包含大小写字母，数字，英文符号。',
    en: 'Password must be 12 - 32 characters long and include uppercase and lowercase letters, digits, and English characters.',
    jp: 'パスワードは12〜32文字で、大文字・小文字の英字、数字、半角記号を含めてください。',
  },
  30151: {
    cn: '密码长度为12-32位字符，必须包含大小写字母，数字，英文符号。',
    en: 'Password must be 12 - 32 characters long and include uppercase and lowercase letters, digits, and English characters.',
    jp: 'パスワードは12〜32文字で、大文字・小文字の英字、数字、半角記号を含めてください。',
  },
  30130: {
    cn: '您的帐号存在非法操作，已被停用。您如果对此存在疑问，请联系您的管理员。',
    en: 'Your account has been deactivated for illegal activity. If you have questions about this, please contact your administrator.',
    jp: 'お客様のアカウントに不正な操作が確認されたため、無効化されました。ご不明な点は管理者にお問い合わせください。',
  },
  30143: {
    cn: '发送频率过快，请稍后再试',
    en: 'Sending frequency beyond limit',
    jp: '送信頻度が高すぎます。しばらくしてから再試行してください',
  },
  30145: {
    cn: '您所在的组织要求您使用商务邮箱访问智慧芽，请通过邮箱登录',
    en: 'Your organization requires you to use your business email address to access Patsnap. Please login via email.',
    jp: 'ご所属の組織では、Patsnap へのアクセスに業務用メールアドレスの使用が必要です。メールアドレスでログインしてください。',
  },
  31002: {
    cn: '无效的手机号',
    en: 'Invalid phone number',
    jp: '携帯番号が無効です',
  },
  610003: {
    cn: '验证码发送频率过高',
    en: 'The frequency of sending verification code is too high',
    jp: '認証コードの送信頻度が高すぎます',
  },
  130066: {
    cn: '当前账号使用存在异常，请明日再来',
    en: 'There is an exception in the current account usage, please come back tomorrow',
    jp: '現在のアカウントの利用に異常があります。明日以降に再度お試しください',
  },
  130072: usageLimitMessage,
  130074: usageLimitMessage,
  130073: usageLimitMessage,
  130097: overLimitMessage,
  42003: {
    cn: '当前检索范围过大，请缩小',
    en: 'The current search range is too large, please narrow it down',
    jp: '現在の検索範囲が広すぎます。範囲を絞り込んでください',
  },
  130099: {
    cn: '导出数量超过每日限制',
    en: 'Export exceed daily limit',
    jp: 'エクスポート件数が1日の上限を超えています',
  },
  130103: {
    cn: '无权限访问他人dashboard',
    en: 'No permission to access this dashboard',
    jp: 'このダッシュボードにアクセスする権限がありません',
  },
  130104: {
    cn: '不存在的dashboard',
    en: 'The dashboard id is not exist',
    jp: 'このダッシュボードは存在しません',
  },
  130105: {
    cn: '验证码无效，请重新发送',
    en: 'Invalid verification code. Please resend the code.',
    jp: '認証コードが無効です。再送信してください。',
  },
  130106: {
    cn: '验证码失效',
    en: 'The verification code has expired.',
    jp: '認証コードの有効期限が切れました。',
  },
  130107: {
    cn: '请上传认证图片',
    en: 'Please upload photo',
    jp: '認証用の画像をアップロードしてください',
  },
  130108: {
    cn: '链接已过期',
    en: 'The link has expired',
    jp: 'リンクの有効期限が切れました',
  },
  130111: {
    cn: '当前药物没有研发状态',
    en: 'No R&D status for current drug',
    jp: 'この医薬品には開発段階の情報がありません',
  },
  130122: {
    cn: '请完善个人信息， 以获得更多产品权限',
    en: 'Please complete personal information to get more privileges.',
    jp: '個人情報を入力すると、より多くの製品権限をご利用いただけます。',
  },
  130134: {
    cn: '您的账号没有创建此邮件提醒的权限，请联系管理员',
    en: 'Your account does not have the permission to create this email alert. Please contact the administrator.',
    jp: 'お客様のアカウントにはこのメールアラートを作成する権限がありません。管理者にお問い合わせください。',
  },
  130136: {
    cn: '当前集团导出总量已达上限，个人账号无法导出，具体请联系管理员',
    en: 'The total amount of group export has reached the limit, personal account can not export data, please contact your administrator.',
    jp: 'グループ全体のエクスポート総量が上限に達したため、個人アカウントではエクスポートできません。詳細は管理者にお問い合わせください。',
  },
}
export function getErrorCodeMessage(errorCode: number, lang: I18nLang): string {
  const langMap = errorCodeMessageMap[errorCode]
  if (!langMap) {
    console.error(`错误状态码:"${errorCode}"没有找到语言配置包,请检查!`)
    return ''
  }
  return getTextByLang(langMap, lang)
}

export function handleError(rt: IHttpWrapError<IAccountErrorResponse | IErrorResponse>, lang: I18nLang) {
  const { numeric_error_code, error_message } = rt.data || {}
  const errMsg = getErrorCodeMessage(numeric_error_code, lang)
  showSingleToast({
    message: errMsg || error_message,
    type: 'error',
  })
}
